"use strict";
printableSummary.classy.controller({
	name: "PrintableSummaryController",
	inject: ["$scope", "$q", "$stateParams", "$sce", "$http",
		"ApplicationService", "CalculationService", "SchoolModelService",
		"authServiceFactory", "HistoryDataModelService", "DateService"],
	init: function()
	{
		var self = this;
		this.$scope.CalculationService = this.CalculationService;
		this.$.$sce = this.$sce;
		this.$.ApplicationService = this.ApplicationService;
		this.$.loading = true;
		$(".index-loading-area").addClass("hidden");

		$(".off-canvas-wrap").removeClass("off-canvas-wrap");
		// hotfixes for page-break-after in chrome
		$(".ng-scope").css("float", "none");
		$("body").css("float", "none");
		$("html").css("float", "none");

        this.authServiceFactory.check();
        var schoolData = this.SchoolModelService.resolveData();
        var applicationData = this.ApplicationService.getData(this.$stateParams.applicationID);

		this.$q.all([applicationData, schoolData]).then(function(result) {
    		self.CalculationService.reCalc();
			self.$.data = self.ApplicationService.getAwardData();
			self.$.school = result[1][0].data[0];
			self.$scope.fam1Inc = self.CalculationService.getTotalIncome();
			if (self.isFam2() && !self.isFam2Excuse()) {
				self.ApplicationService.setFamilyNo(1);
				self.$scope.fam2Inc = self.CalculationService.getTotalIncome();
				self.ApplicationService.setFamilyNo(0);
			}
			self.$.loading = false;
			self.$.history = [];
			//load F1 history
			self.$http.get('/api/family/'+self.ApplicationService.getAwardData().family[0].data[0].familyID+'/historyData').then(function(results)
	        {
	            self.$.history[0] = results.data;
			});
			if (self.isFam2() && !self.isFam2Excuse()) {
				//load F2 history
				self.$http.get('/api/family/'+self.ApplicationService.getAwardData().family[1].data[0].familyID+'/historyData').then(function(results)
				{
					self.$.history[1] = results.data;
				});
			}
		});

		this.loadPresets();
		this.setPreset(1);

	},
	recommendedTuition: function() //Used to calculate awarded tuition for front end
	{
        return parseInt(this.ApplicationService.getAwardData().awardData.recommendedAward.tuition - 
                this.ApplicationService.getAwardData().awardData.recommendedAward.recommendedAward);
	},
	momentFormat: function(datetime)
    {
        var appSubmit = moment(datetime)
        return appSubmit.format('MM-DD-YYYY');
    },
    formatAnswer: function(question)
    {
        //Move this to the backend
        var temp;
        var answer = question.Answer;
        if (question.Q_type == 2)
        {
            temp = question.Answer.split("|");
            temp[0] = temp[0].replaceAll(",");
            temp[0] = temp[0].addCommas();
            if (question.money==1)
                temp[0] = "$" + temp[0];
            if (temp[1]!=='#')
                answer = temp[0] + " - " + temp[1];
            else
                answer = temp[0];
        }
        return answer.toString();
    },
	setPreset: function(index) {
		this.$.displayed = angular.copy(this.presets[index]);
	},
	isFam2Excuse: function() {
		if (this.$.data.family.length===2 && this.$.data.family[1].data[0].Fam_Guard_Excuse)
			return true;
		else
			return false;
	},
	isFam2: function() {
		if (this.$scope.data.family.length===2 && !this.$.data.family[1].data[0].Fam_Guard_Excuse)
			return true;
		else
			return false;
	},
	getAge: function(dob) {
		var dobstring = String(dob);
		var formattedDate = dobstring.substring(0, 4)+ "/"
							+ dobstring.substring(4, 6)+ "/"
							+ dobstring.substring(6, 8);
		var ageDifMs = Date.now() - new Date(formattedDate).getTime();
		var ageDate = new Date(ageDifMs);
		return Math.abs(ageDate.getUTCFullYear() - 1970);
	},
	toInt: function(num) {
		if (typeof num == "undefined") 
			return 0;
		else return parseInt(num);
	},
    getField: function(item, field)
    {
        if (typeof item['x' + field] == 'undefined' || item['x' + field] === null || item['x' + field] == '' || item[field] == item['x' + field])
            return item[field] 
        else
            return item['x' + field];
    },
    loadPresets: function() {
		this.presets = [
			{ //none selected
				"application": {
					"applicants": false,
					"familyStructure": false,
					"recommendedAward": false,
					"flags": false,
					"schoolNotes": false
				},
				"family": {
					0: { //fam1
						"pageBreak": false,
						"familyStructure": false,
						"calculationData": false,
						"assetLiab": false,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": false,
						"parentLetter": false,
						"taxStatus": false,
						"history": false
					},
					1: { //fam2
						"pageBreak": false,
						"familyStructure": false,
						"calculationData": false,
						"assetLiab": false,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": false,
						"parentLetter": false,
						"taxStatus": false,
						"history": false
					}
				},
				"history": { //history
					"pageBreak": false
				}
			},
			{ //minimal selection
				"application": {
					"applicants": true,
					"familyStructure": false,
					"recommendedAward": true,
					"flags": false,
					"schoolNotes": false
				},
				"family": {
					0: { //fam1
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": false,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": false,
						"parentLetter": true,
						"taxStatus": true,
						"history": false
					},
					1: { //fam2
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": false,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": false,
						"parentLetter": true,
						"taxStatus": true,
						"history": false
					}
				},
				"history": { //history
					"pageBreak": false
				}
			},
			{ //award selection
				"application": {
					"applicants": true,
					"familyStructure": false,
					"recommendedAward": true,
					"flags": true,
					"schoolNotes": true
				},
				"family": {
					0: { //fam1
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": true,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": true,
						"parentLetter": true,
						"taxStatus": true,
						"history": false
					},
					1: { //fam2
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": true,
						"vehicles": false,
						"realEstate": false,
						"schoolSpecificQuestions": true,
						"parentLetter": true,
						"taxStatus": true,
						"history": false
					}
				},
				"history": { //history
					"pageBreak": false
				}
			},
			{ //all selected
				"application": {
					"applicants": true,
					"familyStructure": true,
					"recommendedAward": true,
					"flags": true,
					"schoolNotes": true
				},
				"family": {
					0: { //fam1
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": true,
						"vehicles": true,
						"realEstate": true,
						"schoolSpecificQuestions": true,
						"parentLetter": true,
						"taxStatus": true,
						"history": true
					},
					1: { //fam2
						"pageBreak": false,
						"familyStructure": true,
						"calculationData": true,
						"assetLiab": true,
						"vehicles": true,
						"realEstate": true,
						"schoolSpecificQuestions": true,
						"parentLetter": true,
						"taxStatus": true,
						"history": true
					}
				},
				"history": { //history
					"pageBreak": false
				}
			}
		];
    }

});
